import { render, staticRenderFns } from "./HandleField.vue?vue&type=template&id=584ace64&scoped=true&"
import script from "./HandleField.vue?vue&type=script&lang=js&"
export * from "./HandleField.vue?vue&type=script&lang=js&"
import style0 from "./HandleField.vue?vue&type=style&index=0&id=584ace64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584ace64",
  null
  
)

export default component.exports